@if (processedWidgets().length) {
  <ol-widget-container [title]="title()" [headerLink]="headerLink()" [headerActionTemplate]="headerActionTemplate()">
    <div class="list-widget" [style]="containerStyles()" [class]="styleClass()">
      @for (item of processedWidgets(); track item.id) {
        @if (itemTemplate) {
          <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }" />
        }
      }
    </div>
  </ol-widget-container>
}
